import vContactWidget from "./v-contact-widget.vue";
import vContactWidgetIcon from "./v-contact-widget-icon.vue";

export default Vue => {
  Vue.component("v-contact-widget", vContactWidget);
  Vue.component("v-contact-widget-icon", vContactWidgetIcon);
};
